import * as Yup from "yup";

export const COMPANY_NATIONAL_ID_LENGTH = 11;
export const COMPANY_NATIONAL_ID_REGEX = /^\d{11}$/;
export const COMPANY_NATIONAL_ID_REQUIRED_MSG = "شناسه ملی شرکت الزامی است";
export const COMPANY_NATIONAL_ID_FORMAT_MSG =
  "شناسه ملی شرکت باید دقیقاً ۱۱ رقم باشد";
export const COMPANY_NATIONAL_ID_INVALID_MSG = COMPANY_NATIONAL_ID_FORMAT_MSG;
export const COMPANY_NATIONAL_ID_HINT_MSG = "۱۱ رقم";

export const normalizeCompanyNationalIdDigits = (value) =>
  String(value ?? "")
    .trim()
    .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
    .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
    .replace(/\D/g, "");

/** Returns error message, or empty string when valid (exactly 11 digits). */
export const validateCompanyNationalId = (value) => {
  const normalized = normalizeCompanyNationalIdDigits(value);
  if (!normalized) {
    return COMPANY_NATIONAL_ID_REQUIRED_MSG;
  }
  if (!COMPANY_NATIONAL_ID_REGEX.test(normalized)) {
    return COMPANY_NATIONAL_ID_FORMAT_MSG;
  }
  return "";
};

export const yupCompanyNationalIdWhenLegal = () =>
  Yup.string().when("agreementKind", {
    is: (val) => val === "Legal",
    then: (schema) =>
      schema
        .required(COMPANY_NATIONAL_ID_REQUIRED_MSG)
        .test(
          "company-national-id",
          COMPANY_NATIONAL_ID_FORMAT_MSG,
          (value) => !validateCompanyNationalId(value)
        ),
    otherwise: (schema) => schema.nullable(),
  });

export const yupCompanyNationalIdOptional = () =>
  Yup.string()
    .nullable()
    .test("company-national-id", COMPANY_NATIONAL_ID_FORMAT_MSG, (value) => {
      if (!value) {
        return true;
      }
      return !validateCompanyNationalId(value);
    });

export const companyNationalIdInputProps = {
  maxLength: COMPANY_NATIONAL_ID_LENGTH,
  inputMode: "numeric",
};
